import React from "react";
import { Button } from "@/components/ui/button";
import { PaginatedResponse } from "@/types/borrower";

interface ListPagerProps {
  data: Pick<PaginatedResponse<unknown>, "count" | "total_pages" | "current_page"> | undefined;
  onPageChange: (page: number) => void;
}

/** Footer for a server-paginated table; hidden when everything fits on one page. */
const ListPager: React.FC<ListPagerProps> = ({ data, onPageChange }) => {
  if (!data || data.total_pages <= 1) return null;
  const page = data.current_page;

  return (
    <div className="flex flex-wrap items-center justify-end gap-4 border-t px-4 py-3">
      <p className="text-sm text-muted-foreground">
        Page {page} of {data.total_pages} ({data.count} total)
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={page >= data.total_pages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ListPager;
